import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { Question } from '../../../../classes';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
@Component({
  selector: 'question-tags',
  templateUrl: './question-tags.component.html',
  styleUrls: ['./question-tags.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionTagsComponent {
  @Input() question: Question;
  @Input() questionFormGroup: FormGroup;
  subscriptions: Subscription[] = [];
  constructor(private cdRef: ChangeDetectorRef) {}
  ngOnInit() {
    if (this.questionFormGroup)
      this.subscriptions.push(
        this.questionFormGroup.statusChanges.subscribe(() =>
          this.cdRef.detectChanges()
        )
      );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
